var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHelp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0C10.1247 0 0 10.1247 0 22.5C0 34.8753 10.1247 45 22.5 45C34.8753 45 45 34.8753 45 22.5C45 10.1247 34.8753 0 22.5 0ZM24.1874 34.8753H20.8126V31.5004H24.1874V34.8753ZM28.4061 20.532L26.7186 21.9389C25.3117 23.0632 24.468 24.1896 24.468 26.7207H20.8126V25.877C20.8126 23.909 21.6563 22.5021 23.0632 21.0952L25.3138 18.8446C26.1575 18.2814 26.4381 17.4377 26.4381 16.5939C26.4381 14.6259 24.7506 13.219 22.7826 13.219C20.8147 13.219 19.1272 14.6259 19.1272 16.5939H14.9086C14.9086 12.9385 18.2835 9.84415 22.5021 9.84415C26.7207 9.84415 30.0956 12.9385 30.0956 16.5939C30.0956 18.2814 29.2519 19.4056 28.4082 20.532H28.4061Z",
    fill: "#58585A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHelp);
export default __webpack_public_path__ + "static/media/ic-help.2035951d14b76484d3e8bcb102a9b316.svg";
export { ForwardRef as ReactComponent };